"use client";
import { useState } from "react";
import dynamic from "next/dynamic";

import { getCookie } from "helpers/cookies";
import { Modal, Button } from "antd";
import styles from "./Location.pc.module.scss";
const GoogleMap = dynamic(() => import("components/GoogleMap/GoogleMap"), {
  ssr: false
});
const MapClient = ({ data }) => {
  const [open, setOpen] = useState(false);
  const { latitude, longitude, distance, address } = data;
  const userInfo = getCookie("user") || {};

  return (
    <>
      {latitude && longitude ? (
        <>
          {userInfo?.latitude && distance && <p className={styles.mapDistance}>{distance}</p>}
          <div
            className={styles.map_context}
            onClick={(e) => {
              const isMenuBar = document
                .querySelector("[role=menubar]")
                ?.contains((e as any).target);
              if (!isMenuBar) {
                setOpen(true);
              }
            }}
          >
            <GoogleMap
              lat={parseFloat(latitude)}
              lng={parseFloat(longitude)}
              gestureHandling='none'
              zoomControl={false}
              fullscreenControl={false}
              streetViewControl={false}
              clickable={false}
            />
          </div>
        </>
      ) : null}
      <Modal
        width={740}
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key='done' type='primary' onClick={() => setOpen(false)}>
            Done
          </Button>
        ]}
      >
        <div className={styles.workLocal}>
          <div className={styles.workLocal_head}>
            <h3
              style={{
                fontSize: 18,
                height: 60
              }}
            >
              {data.title}
            </h3>
          </div>

          <div className={styles.workLocal_map}>
            <div className={styles.workLocal_map_wrapper}>
              <div
                className={styles.workLocal_map_wrapper_content}
                style={{
                  maxWidth: "100%",
                  height: 230
                }}
                id='googleMapSoaWAErd4'
              >
                {latitude && longitude && (
                  <GoogleMap
                    id='googleMapSoaWAErd4'
                    lat={parseFloat(latitude)}
                    lng={parseFloat(longitude)}
                    gestureHandling='auto'
                    zoomControl={true}
                    fullscreenControl={true}
                    streetViewControl={true}
                    clickable={true}
                    infoWindow={address}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MapClient;
